/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable import/extensions */
import './BtnStyles.css';

const Button = (props) =>
{
	const { size, type, fullWidth, label, buttonType, growOne, onClick } = props;
	const cls = `btn ${size} ${props?.disabled ? 'primarySLight' : type} ${fullWidth} ${growOne} ${buttonType}`;

	// const icon = `img ${white} ${primary}`
	return (
		<button
			className={cls}
			onClick={onClick}
			type={buttonType || 'button'}
			disabled={props.disabled}
			style={{ textAlign: 'center' }}
		>
			{label}
		</button>
	);
};

export default Button;

// size: lg,md,sm
// type, primary,outLine,link
